export const consentPluginConfig = {
  categories: {
    necessary: {
      enabled: true,
      readOnly: true,
    },
    analytics: {},
    marketing: {},
  },
  language: {
    default: 'en',
    translations: {
      en: {
        consentModal: {
          title: 'Cookie Policy.',
          description: 'We are using cookies to give you the best experience on our site and to show you relevant advertising according to our <a href="/cookie-policy" target="_blank" rel="noopener noreferrer">Cookie Policy</a>',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          showPreferencesBtn: 'Manage preferences',
        },
        preferencesModal: {
          title: 'Cookie preferences',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          savePreferencesBtn: 'Save preferences',
          closeIconLabel: 'Close',
          sections: [
            {
              title: 'Cookie usage',
              description: 'We use cookies to ensure the basic functionalities of the website and to enhance your online experience ...',
            },
            {
              title: 'Strictly necessary cookies',
              description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
              linkedCategory: 'necessary',
            },
            {
              title: 'Performance and Analytics cookies',
              description: 'These cookies allow the website to remember the choices you have made in the past',
              linkedCategory: 'analytics',
              cookieTable: {
                headers: {
                  name: 'Name',
                  domain: 'Service',
                  description: 'Description',
                  expiration: 'Expiration',
                },
                body: [
                  {
                    name: '_ga',
                    domain: 'Google Analytics',
                    description: 'Cookie set by <a href="#das">Google Analytics</a>',
                    expiration: 'Expires after 12 days',
                  },
                  {
                    name: '_gid',
                    domain: 'Google Analytics',
                    description: 'Cookie set by <a href="#das">Google Analytics</a>',
                    expiration: 'Session',
                  },
                  {
                    name: 'Matomo',
                    domain: 'https://matomo.org/',
                    description: 'Cookie set by <a href="https://matomo.org/" target="_blank" rel="noopener noreferrer">Matomo</a> for website analytics and performance tracking.',
                    expiration: 'Typically expires after 13 months, depending on configuration.',
                  },
                ],
              },
            },
            {
              title: 'Marketing cookies',
              description: 'Used to track visitors across websites for advertising purposes',
              linkedCategory: 'marketing',
              cookieTable: {
                headers: {
                  name: 'Name',
                  domain: 'Service',
                  description: 'Description',
                  expiration: 'Expiration',
                },
                body: [
                  {
                    name: 'EGASS',
                    domain: 'https://fruits4real.com',
                    description:
                      'Cookie set by <a href="https://fruits4real.com/" target="_blank" rel="noopener noreferrer">EGASS</a> to handle affiliate tracking and conversion attribution.',
                    expiration: 'Typically expires after 30 days.',
                  },
                ],
              },
            },
            {
              title: 'More information',
              description: 'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="/email">contact us</a>.',
            },
          ],
        },
      },
      de: {
        consentModal: {
          title: 'Cookie-Richtlinie.',
          description: 'Wir verwenden Cookies, um Ihnen die bestmögliche Erfahrung auf unserer Website zu bieten und Ihnen relevante Werbung anzuzeigen, gemäß unserer <a href="/cookie-policy" target="_blank" rel="noopener noreferrer">Cookie-Richtlinie</a>.',
          acceptAllBtn: 'Alle akzeptieren',
          acceptNecessaryBtn: 'Nur notwendige ablehnen',
          showPreferencesBtn: 'Einstellungen verwalten',
        },
        preferencesModal: {
          title: 'Cookie-Einstellungen',
          acceptAllBtn: 'Alle akzeptieren',
          acceptNecessaryBtn: 'Nur notwendige ablehnen',
          savePreferencesBtn: 'Einstellungen speichern',
          closeIconLabel: 'Schließen',
          sections: [
            {
              title: 'Verwendung von Cookies',
              description: 'Wir verwenden Cookies, um die grundlegenden Funktionen der Website sicherzustellen und Ihr Online-Erlebnis zu verbessern.',
            },
            {
              title: 'Unbedingt erforderliche Cookies',
              description: 'Diese Cookies sind für das ordnungsgemäße Funktionieren unserer Website unerlässlich. Ohne sie würde die Website nicht korrekt funktionieren.',
              linkedCategory: 'necessary',
            },
            {
              title: 'Leistungs- und Analyse-Cookies',
              description: 'Diese Cookies ermöglichen es der Website, sich an Entscheidungen zu erinnern, die Sie in der Vergangenheit getroffen haben.',
              linkedCategory: 'analytics',
              cookieTable: {
                headers: {
                  name: 'Name',
                  domain: 'Dienst',
                  description: 'Beschreibung',
                  expiration: 'Ablauf',
                },
                body: [
                  {
                    name: '_ga',
                    domain: 'Google Analytics',
                    description: 'Cookie gesetzt von <a href="https://analytics.google.com/" target="_blank" rel="noopener noreferrer">Google Analytics</a> zur Besucheranalyse.',
                    expiration: 'Läuft nach 12 Tagen ab',
                  },
                  {
                    name: '_gid',
                    domain: 'Google Analytics',
                    description: 'Cookie gesetzt von <a href="https://analytics.google.com/" target="_blank" rel="noopener noreferrer">Google Analytics</a> zur Sitzungsverfolgung.',
                    expiration: 'Sitzung',
                  },
                  {
                    name: 'Matomo',
                    domain: 'https://matomo.org/',
                    description: 'Cookie gesetzt von <a href="https://matomo.org/" target="_blank" rel="noopener noreferrer">Matomo</a> zur Analyse und Leistungsüberwachung.',
                    expiration: 'Typischerweise nach 13 Monaten',
                  },
                ],
              },
            },
            {
              title: 'Marketing-Cookies',
              description: 'Verwendet, um Besucher über Websites hinweg zu verfolgen, um relevante Werbung bereitzustellen.',
              linkedCategory: 'marketing',
              cookieTable: {
                headers: {
                  name: 'Name',
                  domain: 'Dienst',
                  description: 'Beschreibung',
                  expiration: 'Ablauf',
                },
                body: [
                  {
                    name: 'EGASS',
                    domain: 'https://fruits4real.com',
                    description:
                      'Cookie gesetzt von <a href="https://fruits4real.com/" target="_blank" rel="noopener noreferrer">EGASS</a> zur Verwaltung von Affiliate-Tracking und Conversion-Attribution.',
                    expiration: 'Typischerweise nach 30 Tagen.',
                  },
                ],
              },
            },
            {
              title: 'Weitere Informationen',
              description: 'Bei Fragen zu unserer Cookie-Richtlinie oder Ihren Auswahlmöglichkeiten wenden Sie sich bitte an uns: <a class="cc-link" href="/email">Kontakt</a>.',
            },
          ],
        },
      },
      es: {
        consentModal: {
          title: 'Política de Cookies.',
          description: 'Utilizamos cookies para brindarte la mejor experiencia en nuestro sitio y mostrarte publicidad relevante de acuerdo con nuestra <a href="/cookie-policy" target="_blank" rel="noopener noreferrer">Política de Cookies</a>.',
          acceptAllBtn: 'Aceptar todo',
          acceptNecessaryBtn: 'Rechazar todo',
          showPreferencesBtn: 'Administrar preferencias',
        },
        preferencesModal: {
          title: 'Preferencias de cookies',
          acceptAllBtn: 'Aceptar todo',
          acceptNecessaryBtn: 'Rechazar todo',
          savePreferencesBtn: 'Guardar preferencias',
          closeIconLabel: 'Cerrar',
          sections: [
            {
              title: 'Uso de cookies',
              description: 'Usamos cookies para garantizar la funcionalidad básica del sitio web y mejorar tu experiencia en línea.',
            },
            {
              title: 'Cookies estrictamente necesarias',
              description: 'Estas cookies son esenciales para el funcionamiento adecuado de nuestro sitio web. Sin ellas, el sitio no funcionaría correctamente.',
              linkedCategory: 'necessary',
            },
            {
              title: 'Cookies de rendimiento y análisis',
              description: 'Estas cookies permiten que el sitio recuerde las elecciones que has hecho en el pasado.',
              linkedCategory: 'analytics',
              cookieTable: {
                headers: {
                  name: 'Nombre',
                  domain: 'Servicio',
                  description: 'Descripción',
                  expiration: 'Expiración',
                },
                body: [
                  {
                    name: '_ga',
                    domain: 'Google Analytics',
                    description: 'Cookie establecida por <a href="https://analytics.google.com/" target="_blank" rel="noopener noreferrer">Google Analytics</a> para análisis de visitantes.',
                    expiration: 'Expira después de 12 días',
                  },
                  {
                    name: '_gid',
                    domain: 'Google Analytics',
                    description: 'Cookie establecida por <a href="https://analytics.google.com/" target="_blank" rel="noopener noreferrer">Google Analytics</a> para seguimiento de sesiones.',
                    expiration: 'Sesión',
                  },
                  {
                    name: 'Matomo',
                    domain: 'https://matomo.org/',
                    description: 'Cookie establecida por <a href="https://matomo.org/" target="_blank" rel="noopener noreferrer">Matomo</a> para análisis y seguimiento del rendimiento.',
                    expiration: 'Normalmente expira después de 13 meses',
                  },
                ],
              },
            },
            {
              title: 'Cookies de marketing',
              description: 'Se utilizan para rastrear a los visitantes a través de sitios web con fines publicitarios.',
              linkedCategory: 'marketing',
              cookieTable: {
                headers: {
                  name: 'Nombre',
                  domain: 'Servicio',
                  description: 'Descripción',
                  expiration: 'Expiración',
                },
                body: [
                  {
                    name: 'EGASS',
                    domain: 'https://fruits4real.com',
                    description:
                      'Cookie establecida por <a href="https://fruits4real.com/" target="_blank" rel="noopener noreferrer">EGASS</a> para gestionar el seguimiento de afiliados y la atribución de conversiones.',
                    expiration: 'Normalmente expira después de 30 días.',
                  },
                ],
              },
            },
            {
              title: 'Más información',
              description: 'Para cualquier consulta relacionada con nuestra política de cookies y tus opciones, por favor <a class="cc-link" href="/email">contáctanos</a>.',
            },
          ],
        },
      },
    },
  },
  guiOptions: {
    consentModal: {
      layout: 'box',
      position: 'bottom center',
      flipButtons: false,
      equalWeightButtons: true,
    },
    preferencesModal: {
      layout: 'box',
      flipButtons: false,
      equalWeightButtons: true,
    },
  },
};

export default consentPluginConfig;
